import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import { ShoppingBag, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "../context/CartContext";
import { INSTAGRAM, scrollToId } from "../lib/api";

const NavLink = ({ id, label }) => {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const go = () => {
    if (pathname === "/") scrollToId(id);
    else {
      nav("/");
      setTimeout(() => scrollToId(id), 450);
    }
  };
  return (
    <button data-testid={`nav-${id}`} onClick={go} className="group relative font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:text-white">
      {label}
      <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#00FF66] transition-transform duration-300 group-hover:scale-x-100" />
    </button>
  );
};

export const Header = () => {
  const { count, setOpen } = useCart();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-4 py-3.5 md:px-8">
        <Link to="/" data-testid="nav-logo"><Logo /></Link>
        <nav className="hidden items-center gap-9 md:flex">
          <NavLink id="shop" label="Shop" />
          <NavLink id="lookbook" label="Lookbook" />
          <NavLink id="manifesto" label="Manifesto" />
        </nav>
        <div className="flex items-center gap-2">
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="nav-instagram" className="grid h-10 w-10 place-items-center border border-white/10 text-zinc-300 transition-colors hover:border-[#00FF66] hover:text-[#00FF66]">
            <Instagram className="h-4 w-4" />
          </a>
          <button data-testid="cart-toggle-btn" onClick={() => setOpen(true)} className="flex h-10 items-center gap-2 bg-[#00FF66] px-4 font-mono text-xs font-bold uppercase tracking-widest text-black transition-transform active:scale-95">
            <ShoppingBag className="h-4 w-4" />
            <span className="hidden sm:inline">Bag</span>
            <motion.span key={count} initial={{ scale: 1.6 }} animate={{ scale: 1 }} data-testid="nav-cart-count">[{count}]</motion.span>
          </button>
        </div>
      </div>
      <nav className="flex justify-center gap-8 border-t border-white/10 py-2 md:hidden" data-testid="mobile-nav">
        <NavLink id="shop" label="Shop" />
        <NavLink id="lookbook" label="Lookbook" />
        <NavLink id="manifesto" label="Manifesto" />
      </nav>
      <motion.div style={{ scaleX }} className="h-[2px] origin-left bg-[#00FF66]" />
    </header>
  );
};
